// Optimize
import $ from 'jquery';
import Module from './module.js';
import Flickity from 'flickity'
import 'flickity-as-nav-for'


class Carousel extends Module {

  constructor(element, $) {
    super()

    this.element = element
    this.nav = $(element).parent().find('.carousel-nav')[0]
    this.init()
  }

  init() {


      this.flkty = new Flickity( this.element , {
        prevNextButtons : true,
        wrapAround : false,
        pageDots : false,
        draggable : true,
        resize: true
        // selectedAttraction: 0.025,
        // friction: 0.4
      })

      // this.nvflickity = new Flickity ( this.nav ,{
      //   asNavFor: this.element ,
      //   prevNextButtons : false,
      //   contain: true,
      //   pageDots: false
      // });

  }



}


Carousel.selector = `.carousel`;
module.exports = Carousel
